import type { FC, ReactNode } from 'react';
import { CookiesProvider } from 'react-cookie';
import { tokenManager } from '@/shared/lib/storage';
import { AuthProvider } from './AuthProvider';
import { QueryProvider } from './QueryProvider';

type AppProvidersProps = {
  children: ReactNode;
};

/**
 * アプリケーション全体のProviders統合
 *
 * 重要: tokenManagerとCookiesProviderが同じCookiesインスタンスを共有するように設定
 * これにより、tokenManager.setAuthToken/clearTokensの呼び出しがReactの再レンダリングをトリガーする
 */
export const AppProviders: FC<AppProvidersProps> = ({ children }) => {
  return (
    <CookiesProvider cookies={tokenManager.getCookiesInstance()}>
      <QueryProvider>
        <AuthProvider>{children}</AuthProvider>
      </QueryProvider>
    </CookiesProvider>
  );
};
